export const menuData = {
  "Main Dish": [
    {
      imgPath: "assets/images/food/dish-1.jpg.webp",
      name: "grilled beef",
      desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.",
      price: "$2.90",
      id: "dish1",
    },
    {
      imgPath: "assets/images/food/dish-2.jpg.webp",
      name: "grilled beef",
      desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.",
      id: "dish2",
      price: "$2.90"
    },
    {
      imgPath: "assets/images/food/dish-3.jpg.webp",
      name: "grilled beef",
      id: "dish3",
      desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
      price: "$2.90"
    },
  ],
  Drinks: [
    {
      imgPath: "assets/images/food/drink-1.jpg.webp",
      name: "lemonade juice",
      id: "drink1",
      desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
      price: "$2.90"
    },
    {
      imgPath: "assets/images/food/drink-2.jpg.webp",
      name: "pinapple juice",
      desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
      id: "drink2",
      price: "$2.90"
    },
    {
      imgPath: "assets/images/food/drink-3.jpg.webp",
      name: "soda drinks",
      id: "drink3",
      desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
      price: "$2.90"
    },
  ],
  Desserts: [
    {
      imgPath: "assets/images/food/dessert-1.jpg.webp",
      name: "hot cake honey",
      id: "dessert1",
      desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
      price: "$2.90"
    },
    {
      imgPath: "assets/images/food/dessert-2.jpg.webp",
      id: "dessert2",
      name: "hot cake honey",
      desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
      price: "$2.90"
    },
    {
      imgPath: "assets/images/food/dessert-3.jpg.webp",
      id: "dessert3",
      name: "hot cake honey",
      desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
      price: "$2.90"
    },
  ]
}
